<script setup lang="ts">
  import { normalizeNumericValue } from '@borg/utils';

  withDefaults(
    defineProps<{
      visible?: boolean;
    }>(),
    {
      visible: true,
    },
  );

  const containerElement = ref<HTMLElement>();
  const { height: windowHeight } = useWindowSize();
  const { bottom: containerBottom } = useElementBounding(containerElement);
  const containerDistanceFromBottom = computed(() =>
    Math.round(windowHeight.value - containerBottom.value),
  );
  const shadowVisibilityFactor = computed(() =>
    normalizeNumericValue(containerDistanceFromBottom.value, 0, 50, 1, 0),
  );
  const shadowY = computed(
    () => `${normalizeNumericValue(shadowVisibilityFactor.value, 0, 1, 0.5, -0.5)}rem`,
  );
  const shadowBlur = computed(() => `${shadowVisibilityFactor.value}rem`);
</script>

<template>
  <Transition>
    <LayoutFragment
      v-show="visible"
      ref="containerElement"
      class="job-actions"
    >
      <LayoutFragment
        align="page"
        class="job-actions__items"
      >
        <slot />
      </LayoutFragment>
    </LayoutFragment>
  </Transition>
</template>

<style scoped lang="scss">
  .job-actions {
    position: sticky;
    bottom: -1px;
    background-color: var(--mp-color-surface-50);
    box-shadow: 0 v-bind(shadowY) v-bind(shadowBlur) hsla(0 0% 0% / 0.08);
    clip-path: inset(-999px 0px 0px 0px);

    @include dark-mode {
      box-shadow: 0 v-bind(shadowY) v-bind(shadowBlur) hsla(0 0% 0% / 0.5);
    }

    &__items {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: var(--mp-space-30);
      padding-top: var(--mp-space-50);
      padding-bottom: var(--mp-space-50);
    }
  }

  .v-enter-active,
  .v-leave-active {
    transition:
      opacity 0.5s ease-in-out,
      transform 0.5s ease-in-out;
    opacity: 1;
  }

  .v-enter-from,
  .v-leave-to {
    transform: translateY(100%);
    opacity: 0;
    margin-top: 0;
  }
</style>
